import { useCallback, useEffect } from 'react';

const eventName = 'promo-click';

export function EventFactory(desc, target = {}, prefix = '') {
  return new CustomEvent(eventName, {
    bubbles: true,
    detail: {
      link: desc.link,
      target: desc.linkTarget,
      isMainTarget: desc.isMainTarget ?? false,
      origin: {
        id: desc.id,
        type: desc.type,
        target: desc,
        caption: target.innerText ?? '',
        action: `${prefix}click`,
      },
    },
  });
}
export function useClickEvent(desc, prefix = '') {
  return useCallback(
    (ev) => {
      ev.preventDefault();
      ev.stopPropagation();

      if (desc.formId) {
        document
          .getElementById(desc.formId)
          ?.dispatchEvent(new Event('form-submit'));
      }

      const event = EventFactory(desc, ev.target, prefix);

      ev.target.dispatchEvent(event);

      /*
     assume: every button (instead just anchor)
     MAY have some side effect described in sideEffects property
     example: send poll vote via pub to topic.
     The effect MUST contain:
      - `name`
      - `init` - MUST match CustomEventInit
    */
      (desc.sideEffects || []).forEach((effect) => {
        ev.target.dispatchEvent(new CustomEvent(effect.name, effect.init));
      });
    },
    [desc],
  );
}

export function useClickListener(ref, listener) {
  useEffect(() => {
    const target = ref.current;

    target.addEventListener(eventName, listener, false);

    return () => {
      target.removeEventListener(eventName, listener, false);
    };
  }, [listener, ref]);
}
